export const ROUTES = {
	plansComparison: '/plans-comparison',
	requestContact: '/request-contact',
	intro: '/intro',
	root: '/',
	serviceError: '/service-error',

	subscriptionSelectPlan: '/subscription-select-plan',
	subscriptionSelectAccount: '/subscription-select-account',
	subscriptionTermsAndConditionsSoftware: '/subscription-terms-and-conditions-software',
	subscriptionTermsAndConditionsBank: '/subscription-terms-and-conditions-bank',
	subscriptionResumeAndAuthorization: '/subscription-resume-and-authorization',
	subscriptionConclusion: '/subscription-conclusion',

	integratedSolutionSelectSolution: '/integrated-solution-select-solution',
	integratedSolutionSelectAccount: '/integrated-solution-select-account',
	integratedSolutionTermsAndConditionsBank: '/integrated-solution-terms-and-conditions-bank',
	integratedSolutionResumeAndAuthorization: '/integrated-solution-resume-and-authorization',
	integratedSolutionConclusion: '/integrated-solution-conclusion',
};

export type Routes = keyof typeof ROUTES;

export const subscriptionFlowPath = [
	ROUTES.subscriptionSelectPlan,
	ROUTES.subscriptionSelectAccount,
	ROUTES.subscriptionTermsAndConditionsSoftware,
	ROUTES.subscriptionTermsAndConditionsBank,
	ROUTES.subscriptionResumeAndAuthorization,
	ROUTES.subscriptionConclusion,
];

export const integratedSolutionFlowPath = [
	ROUTES.integratedSolutionSelectSolution,
	ROUTES.integratedSolutionSelectAccount,
	ROUTES.integratedSolutionTermsAndConditionsBank,
	ROUTES.integratedSolutionResumeAndAuthorization,
	ROUTES.integratedSolutionConclusion,
];

export const noFlowPath = [ROUTES.requestContact, ROUTES.intro];
